import { Injectable, ViewChild } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { FetchData } from 'app/shared/generalMethods';
import moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class AgeValidation {
    @ViewChild('addChildrenNgForm') addChildrenNgForm: NgForm;
    addChildrenForm: FormGroup;
    policyYounger = '';
    policyElder = '';
    userRecord: any;
    policyText = '';
    policyLastUpdate = '';
    childMaxAge = 0;
    childMinAge = 0;

    constructor(private _fetchData: FetchData) {}

    ageChange(selectedDateOfBirth: Date): any {
        this.userRecord = this._fetchData.data;
        const today = new Date();
        const age = today.getFullYear() - selectedDateOfBirth.getFullYear();

        if (
            age >= this.userRecord.lstPolicies[0].Min_Age__c &&
            age <= this.userRecord.lstPolicies[0].Max_Age__c
        ) {
            this.policyText = this.policyYounger;
            this.policyLastUpdate = moment(
                this.userRecord.lstPolicies[0].LastModifiedDate
            ).format('YYYY-MM-DD');
        } else if (
            age >= this.userRecord.lstPolicies[1].Min_Age__c &&
            age <= this.userRecord.lstPolicies[1].Max_Age__c
        ) {
            this.policyText = this.policyElder;
            this.policyLastUpdate = moment(
                this.userRecord.lstPolicies[1].LastModifiedDate
            ).format('YYYY-MM-DD');
        } else {
            this.policyText = '';
            this.policyLastUpdate = '';
        }
        return age;
    }
}
